module.exports = function() {
  return new Worker(__webpack_public_path__ + "21deeae9e5dd0bf71fd5.worker.js");
};